import { useState, useMemo, useCallback } from 'react';
import { useFetchPromise } from '@rad/hooks';
import { getParcelKinds } from '../../../../../common/network/parcel-kind';
/// The legend describes the whole parcel kind catalog rather than whatever happens to be loaded.
/// A zoomed-out viewport comes back as pre-aggregated grid cells that carry no kind at all, so
/// deriving the legend from the items collapsed it to a single entry.
///
/// `kindFilter` narrows that catalog to the kinds the map is actually querying for, so a filtered
/// map doesn't offer toggles for kinds the server excluded. As with the query filter itself, an
/// empty list means every kind. Pass a memoized array — it feeds a memo.
export const useLegend = (kindFilter) => {
    const [isLegendOpen, setIsLegendOpen] = useState(false);
    const [hiddenKinds, setHiddenKinds] = useState(new Set());
    const [showUnclaimed, setShowUnclaimed] = useState(true);
    const [kinds] = useFetchPromise(getParcelKinds());
    const uniqueKinds = useMemo(() => {
        const catalog = (kinds !== null && kinds !== void 0 ? kinds : []).map(kind => (Object.assign(Object.assign({}, kind), { 'id': kind.name })));
        return !kindFilter || kindFilter.length === 0
            ? catalog
            : catalog.filter(kind => kindFilter.includes(kind.name));
    }, [kinds, kindFilter]);
    const toggleKind = useCallback((kindName) => {
        setHiddenKinds(prev => {
            const next = new Set(prev);
            if (next.has(kindName))
                next.delete(kindName);
            else
                next.add(kindName);
            return next;
        });
    }, []);
    const toggleUnclaimed = useCallback(() => setShowUnclaimed(prev => !prev), []);
    const toggleLegend = useCallback(() => setIsLegendOpen(prev => !prev), []);
    const closeLegend = useCallback(() => setIsLegendOpen(false), []);
    return { isLegendOpen, toggleLegend, closeLegend, hiddenKinds, uniqueKinds, toggleKind, showUnclaimed, toggleUnclaimed };
};
